// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1sAWx","col":"CardReaderDesc_col__20kxz","label":"CardReaderDesc_label__1W3P2"};